module.exports = __webpack_public_path__ + "images/4f9436a2aee70de9eca023a502ef7f9a-vietnam.jpg";